(function () {
  'use strict';

  var NAV_ID   = 'JourneyFilterNav';
  var GRID_SEL = '.grid.grid--uniform';

  // Map sidebar data-journey values to actual Shopify collection handles
  var COLLECTION_MAP = {
    'pregnancy':       '/collections/pregnancy',
    'breastfeeding':   '/collections/breastfeeding',
    'toddler':         '/collections/toddler',
    'nutrasupplement': '/collections/nutrasupplement',
    'bundles':         '/collections/bundles',
    '':                null   // "View all" — restore original grid
  };

  var originalGridHTML = null;

  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.getElementById(NAV_ID);
    if (!nav) return;

    var buttons = nav.querySelectorAll('.omm-sidebar-collections__link[data-journey]');
    if (!buttons.length) return;

    // Cache the initial grid so we can restore it on "View all"
    var grid = document.querySelector(GRID_SEL);
    if (grid) originalGridHTML = grid.innerHTML;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var journey = this.dataset.journey;

        // Update active states
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        if (journey === '') {
          // "View all" — restore original grid
          restoreAll(grid);
          history.pushState({ journey: '' }, '', window.location.pathname);
          return;
        }

        var collectionUrl = COLLECTION_MAP[journey];
        if (!collectionUrl) return;

        fetchCollection(collectionUrl, journey);
      });
    });

    // Browser back / forward
    window.addEventListener('popstate', function (e) {
      var journey = e.state ? e.state.journey : '';
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.journey === journey);
      });
      if (!journey) {
        restoreAll(document.querySelector(GRID_SEL));
      } else {
        var url = COLLECTION_MAP[journey];
        if (url) fetchCollection(url, journey);
      }
    });
  });

  function fetchCollection(collectionUrl, journey) {
    var grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    setLoading(grid, true);

    // ?view=ajax uses templates/collection.ajax.liquid
    // which renders just our custom product cards with {% layout none %}
    fetch(collectionUrl + '?view=ajax', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        grid.innerHTML = html;
        setLoading(grid, false);

        // Update browser URL
        history.pushState({ journey: journey }, '', collectionUrl);

        // Scroll to grid top
        var top = grid.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      })
      .catch(function (err) {
        console.warn('[JourneyFilter] fetch failed:', err);
        setLoading(grid, false);
      });
  }

  function restoreAll(grid) {
    if (!grid || !originalGridHTML) return;
    grid.innerHTML = originalGridHTML;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function setLoading(grid, on) {
    grid.style.opacity          = on ? '0.35' : '1';
    grid.style.pointerEvents    = on ? 'none' : '';
    grid.style.transition       = 'opacity 0.2s ease';
  }

})();
